import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42n3NOwqAMBRE0ex/exYqAVMoiC/xE8hDEMn1U2ilAzPVgTH8ZzfXdn3ET8rgE3NckaAk3V5QWsG1C0Ul1E3AuvHGD8j57MfFAR3WfGI99nizAAAAAElFTkSuQmCC"};
